import React from 'react'
import { IDropdownOption } from 'components/forms/Dropdown'
import { IconButton } from 'transfix-ui/components/IconButton'
import OverflowMenu, { useOverflowToggle } from 'transfix-ui/components/OverflowMenu'
import { TableCell } from 'transfix-ui/components/Table'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { DeleteIcon, EllipsisIcon, EditIcon } from 'transfix-icons'

interface ISavedLanesTableOptionsCellProps {
  savedLane: LaneAlert
  onDelete: (savedLane: LaneAlert) => void
  onEdit: (savedLane: LaneAlert) => void
}

export const SavedLanesTableOptionsCell = ({
  onDelete: onDeleteProp,
  onEdit: onEditProp,
  savedLane,
}: ISavedLanesTableOptionsCellProps) => {
  const { id } = savedLane || {}
  const onDelete = () => onDeleteProp(savedLane)
  const onEdit = () => onEditProp(savedLane)
  const { clickOverflowTrigger, expanded, setExpanded } = useOverflowToggle()

  const overflowOptions: IDropdownOption[] = [
    {
      label: 'Edit',
      action: onEdit,
      itemComponent: (
        <div className='flex flex-row items-center'>
          <EditIcon size='large' />
          <span className='ml2'>Edit</span>
        </div>
      ),
    },
    {
      label: 'Delete',
      action: onDelete,
      itemComponent: (
        <div className='flex flex-row items-center'>
          <DeleteIcon size='large' />
          <span className='ml2'>Delete</span>
        </div>
      ),
    },
  ]

  return (
    <TableCell dataTest='saved-lane-options'>
      <OverflowMenu
        alignment='left'
        dropdownId={`saved-lane-${id}-dropdown`}
        dataTest='saved-lane-menu'
        options={overflowOptions}
        expanded={expanded}
        onExpanded={setExpanded}
        trigger={
          <IconButton
            label='overflow-trigger'
            Icon={EllipsisIcon}
            onClick={clickOverflowTrigger}
            data-test='saved-lane-menu-button'
            size='large'
          />
        }
      />
    </TableCell>
  )
}
